/**
 * Based on https://github.com/haldarmahesh/use-mobile-detect-hook/blob/master/src/index.ts
 */
import { useEffect, useState } from 'react';
import debounce from 'lodash.debounce';

interface IDeviceIDState {
  isMobile: boolean;
  isDesktop: boolean;
  isAndroid: boolean;
  isIos: boolean;
  isSSR: boolean;
}

const getMobileDetect = (userAgent: string) => {
  const isAndroid = Boolean(userAgent.match(/Android/i));
  const isIos = Boolean(userAgent.match(/iPhone|iPad|iPod/i));
  const isOpera = Boolean(userAgent.match(/Opera Mini/i));
  const isWindows = Boolean(userAgent.match(/IEMobile/i));
  const isSSR = Boolean(userAgent.match(/SSR/i));

  const isMobile = Boolean(isAndroid || isIos || isOpera || isWindows);
  const isDesktop = Boolean(!isMobile && !isSSR);
  return {
    isMobile,
    isDesktop,
    isAndroid,
    isIos,
    isSSR,
  };
};

const defaultState: IDeviceIDState = {
  isMobile: false,
  isDesktop: true,
  isAndroid: false,
  isIos: false,
  isSSR: false,
};

const useDevice = () => {
  /**
   *
   */
  const toggleWidgets = () => {
    if (window.innerWidth < 768) {
      setState({
        ...state,
        isMobile: true,
        isDesktop: false,
      });
    } else {
      setState({
        ...state,
        isMobile: false,
        isDesktop: true,
      });
    }
  };

  useEffect(() => {
    if (!getMobileDetect(navigator.userAgent).isMobile) {
      window.addEventListener(
        'resize',
        debounce(() => {
          toggleWidgets();
        }, 200)
      );
      return () =>
        window.removeEventListener(
          'resize',
          debounce(() => {
            toggleWidgets();
          }, 200)
        );
    }
    // eslint-disable-next-line
  }, []);
  const [state, setState] = useState<IDeviceIDState>(defaultState);

  useEffect(() => {
    if (navigator.userAgent) {
      setState(getMobileDetect(navigator.userAgent));
    } else {
      setState(getMobileDetect('SSR'));
    }
  }, []);

  return {
    ...state,
  };
};

export default useDevice;
